// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1E_c_","col":"Table_col__2TXM0","fulfillmentStatus":"Table_fulfillmentStatus__GtfxE","emailCol":"Table_emailCol__M0JmE"};